export var CLOSE_FILTER_DIALOG = 'CLOSE_FILTER_DIALOG';